import { LocationTiers } from "./DestinationCrossLinkEnums";

export const getFormatTextLocationKey = (geoType: string) => {
  switch (geoType) {
    case LocationTiers.CITY:
      return "destinationCrossLink.city.linkTo";
    case LocationTiers.REGION:
      return "destinationCrossLink.provinceState.linkTo";
    case LocationTiers.COUNTRY:
      return "destinationCrossLink.country.linkTo";
    default:
      return "destinationCrossLink.city.linkTo";
  }
};
